import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

const PortalContext = createContext<HTMLDivElement | null>(null);

export const PortalProvider = PortalContext.Provider;

export function useWidgetPortal() {
  return useContext(PortalContext);
}

/** Renders children into the widget's portal container (escapes overflow/transform ancestors) */
export function WidgetPortal({ children }: { children: ReactNode }) {
  const container = useWidgetPortal();
  if (!container) return null;
  return createPortal(children, container);
}
